<template>
    <div v-if="allowed.read" class="cedex-dependencies-root flex-root-row">
        <div class="flex-root-column editor-box">
            <div class="editor-table cedex-codes" ref="cedexCodeTable">
                <table class="vcs-table">
                    <tr>
                        <th
                            v-for="header in columns"
                            :key="header.id"
                            v-show="visibleColumns[header.id]"
                            class="vcs-table-header"
                            :class="(ownSortingColumn === header.id ? 'sorted' + (ownSortingDirection === 'asc' ? ' sorted-ascending' : ' sorted-descending' ) : '')"
                            :style="(header.width ? 'width: ' + header.width + 'px;' : '')"
                            @click="changeSorting(header.id)"
                        >
                            <div class="vcs-table-header-title">{{ $t(header.title) }}{{
                                header.required ? ' *' : ''
                            }}</div>
                            <div
                                v-show="header.filter"
                                class="vcs-table-header-filter"
                                :class="{active: activeFilterValues[header.id] && activeFilterValues[header.id].length}"
                                @click.stop="showFilter(header.id)"
                                :title="filterTitle(header.id)"
                            />
                        </th>
                    </tr>
                    <tr
                        v-for="(dependency, index) in paginatedCodeData"
                        :key="index + '_' + dataLoaded"
                    >
                        <!-- <td>{{index}}</td> -->
                        <CedexDependenciesSelectTableCell
                            v-if="visibleColumns.isoCodes"
                            :readonly="true"
                            type="isoCode"
                            :value="dependency.isoCodes.join(',')"
                            :allValuesObject="isoCodes"
                            :allValuesArray="isoCodesArray"
                            :codeTexts="true"
                            :multiSelect="true"
                            :groupValuesMap="isoCodeToSurveyTypeName"
                        />
                        <CedexDependenciesSelectTableCell
                            v-if="visibleColumns.locationCodes"
                            :readonly="true"
                            type="locationCode"
                            :value="dependency.locationCodes.join(',')"
                            :allValuesObject="locationCodes"
                            :allValuesArray="locationCodesArray"
                            :codeTexts="true"
                            :multiSelect="true"
                            :groupValuesMap="locationCodePrefixToViewTypeName"
                            :useLineTextEllipsis="true"
                        />
                    </tr>
                </table>
            </div>
            <Pagination
                :pageCount="pageCount"
                :page-size="pageSize"
                :visible-buttons="7"
                v-model="currentPage"
                @input="setScrollTop"
                @pageSizeChange="setPaginationChange"
            />
            <div v-show="loading" class="loading"></div>
        </div>

        <TableFilters
            ref="dependencyFilters"
            :filters="filters"
            @change="onFiltersChange"
        />
    </div>
</template>

<script>
import Pagination from "../Table/Pagination.vue";
import i18n from '../../i18n';
import TableFilters from "../Table/Filter/TableFilters.vue"
import authorization from "../../plugins/authorization";
import axios from "axios";
import {popupShowTime} from "../../plugins/constants";
import CedexDependenciesSelectTableCell from "./CedexDependenciesSelectTableCell.vue";

export default {
    name: "IsoCodeToLocationCodeDependenciesTable",
    components: {
        CedexDependenciesSelectTableCell,
        Pagination,
        TableFilters
    },
    props: {
        columns:  Array,
    },
    created() {
        this.loadData('initial');
    },
    data: function () {
        return {
            dependencies:                     {},
            isoCodes:                         {},
            locationCodes:                    {},
            isoCodeToSurveyTypeName:          {},
            locationCodePrefixToViewTypeName: {},
            dataLoaded:               false,
            loading:                  false,

            // Pagination
            paginationVisibleButtons: 7,
            currentPage:              1,
            pageSize:                 100,

            // Sorting
            ownSortingColumn:         null,
            ownSortingDirection:      null,

            // Filter
            activeFilterValues:       {
                isoCodes:      [],
                locationCodes: [],
            },
            activeFilter:             false,
            availableFilterValues:    {},

            // Access rights
            allowed: {
                read: authorization.isAllowed('Settings/CEDEX Settings/Dependencies/ISO Code to Location Code Dependency/View'),
            },
        }
    },
    watch: {
        sortingColumn: function () {
            this.ownSortingColumn = this.sortingColumn;
        },
        sortingDirection: function () {
            this.ownSortingDirection = this.sortingDirection;
        }
    },
    methods: {
        loadData(type) {
            let loadIdentifier = [];
            Object.keys(this.activeFilterValues).forEach((column) => {
                loadIdentifier.push(this.activeFilterValues[column].join(','));
            });
            loadIdentifier.push(this.ownSortingColumn);
            loadIdentifier.push(this.ownSortingDirection);
            loadIdentifier = loadIdentifier.join('##');

            console.log('load id', loadIdentifier);

            if (
                type !== 'initial'
                && this.dataLoaded === loadIdentifier
            ) {
                return true;
            }

            this.dataLoaded = loadIdentifier;
            this.showLoading();
            this.currentPage = 1;

            axios
                .get(
                    'cedexSettings/isoLocationDependencies',
                    {
                        params: {
                            type:   type,
                            filter: this.activeFilterValues,
                            sorting: {
                                column:    this.ownSortingColumn,
                                direction: this.ownSortingDirection
                            }
                        }
                    }
                )
                .then(response => {

                    this.dependencies = response.data.dependencies;

                    if (type === 'initial') {
                        this.isoCodes                         = response.data.isoCodes;
                        this.locationCodes                    = response.data.locationCodes;
                        this.isoCodeToSurveyTypeName          = response.data.isoCodeToSurveyTypeName;
                        this.locationCodePrefixToViewTypeName = response.data.locationCodePrefixToViewTypeName;
                    }

                    return response;
                }).catch(error => {
                    console.log(error);
                    this.showMessage(i18n.t('Dependencies loading failed.'), 'error', popupShowTime);
                }).then(() => {
                    this.dataLoaded = true;
                    this.hideLoading();
                    this.showMessage(i18n.t('Dependencies loaded.'), 'success', popupShowTime);
                });
        },
        showMessage(message, state, time) {
            this.$emit('showMessage', message, state, time);
        },
        filterTitle(columnId) {
            if (this.activeFilterValues[columnId].length === 0) {
                return '';
            }

            let column;
            this.columns.forEach((currentColumn) => {
                if (currentColumn.id === columnId) {
                    column = currentColumn;
                }
            })

            let output;
            if (column.filter === 'data') {
                let filterData = false;
                this.filters.forEach(iteratingFilter => {
                    if (iteratingFilter.name === columnId) {
                        filterData = iteratingFilter.data;
                    }
                });
                if (filterData === false) {
                    return '';
                }
                // extract filter names
                let texts = [];
                filterData.forEach(filter => {
                    if (this.activeFilterValues[columnId].includes(filter.id)) {
                        texts.push(filter.name);
                    }
                });
                // join names with max 10 results and a '+ x more' option

                if (texts.length > 10) {
                    output = texts.slice(0, 10).join('\r\n') + '\r\n+ ' + (texts.length - 10) + ' ' + i18n.t('more');
                } else {
                    output = texts.join('\r\n');
                }
            } else if (column.filter === 'bool') {
                output = i18n.t((this.activeFilterValues[columnId] ? '' : 'in') + 'active');
            } else if (column.filter === 'string') {
                output = i18n.t('contains') + ': ' + this.activeFilterValues[columnId];
            }

            return output;
        },
        setScrollTop() {
            this.$refs.cedexCodeTable.scrollTo(0, 0);
        },
        setPaginationChange(pageSize) {
            this.pageSize = pageSize;
            if (this.currentPage > this.pageCount) {
                this.currentPage = this.pageCount;
            }
        },
        changeSorting(columnId) {
            return columnId; // deactivated
            /*
            if (this.ownSortingColumn === columnId) {
                if (this.ownSortingDirection === 'desc') {
                    this.ownSortingDirection = 'asc';
                } else {
                    this.ownSortingDirection = 'desc';
                }
            } else {
                this.ownSortingDirection = 'desc';
            }

            this.ownSortingColumn = columnId;

            this.loadData('sorting');
            */
        },
        showFilter(id) {
            this.$refs.dependencyFilters.activeFilter = id;
        },
        onFiltersChange(filterData) {
            if (JSON.stringify(this.activeFilterValues) === JSON.stringify(filterData)) {
                return false;
            }

            Object.assign(this.activeFilterValues, filterData);
            this.loadData('filter');
        },
        showLoading() {
            this.loading = true;
        },
        hideLoading() {
            this.loading = false;
        },
        setAvailableFilterValues(filters) {
            let availableFilterValues = {};
            Object.keys(filters).forEach((name) => {
                availableFilterValues[name] = filters[name];
            });
            this.availableFilterValues = availableFilterValues;
        },
        convertCodes(type) {
            let array = [];
            for (let code in this[type + 's']) {
                let element = {
                    id:   code,
                    name: code + ' - ' + this[type + 's'][code],
                };

                array.push(element);
            }

            return array;
        },
    },
    computed: {
        paginatedCodeData() {
            let dependencyKeys = Object.keys(this.dependencies);
            if (dependencyKeys.length === 0) {
                return [];
            }
            let start = (this.currentPage - 1) * this.pageSize;
            let end = Math.min(this.currentPage * this.pageSize, dependencyKeys.length);
            let firstLine = Object.assign({}, this.dependencies[dependencyKeys[start]]);

            let paginatedData = [firstLine];
            for (let i = start + 1; i < end; i++) {
                paginatedData.push(Object.assign({}, this.dependencies[dependencyKeys[i]]));
            }

            return paginatedData;
        },
        visibleColumns() {
            let visibleColumns = [];
            for (let columnIndex in this.columns) {
                visibleColumns[this.columns[columnIndex].id] = this.columns[columnIndex].visible;
            }
            return visibleColumns;
        },
        columnOrder() {
            let columnOrder = [];
            for (let columnIndex in this.columns) {
                columnOrder.push(this.columns[columnIndex].id);
            }
            return columnOrder;
        },
        pageCount() {
            return Math.ceil(Object.keys(this.dependencies).length / this.pageSize);
        },
        paginationOffset() {
            return (this.currentPage - 1) * this.pageSize;
        },
        filters() {
            /*
             * Define filters here!
             *
             * Generates a filter object array.
             * Each filter has a name, title (display), type (data/input/...)
             * and if type = data a data array of selectable values.
             *
             * Example:
             * filters = [{
             *      name:  "isoCode"
             *      title: "ISO Code"
             *      type:  "data"
             *      data:  [{
             *          id:   "42G0"
             *          name: "42G0 - General Purpose Cont."
             *      }]
             * }]
             */
            let filters = [];
            for (let key in this.columns) {
                let column = this.columns[key];

                if (
                    !!column.filter
                    && this.layoutType !== column.id
                ) {
                    let filter = {
                        name:  column.id,
                        title: column.title,
                        type:  column.filter,

                    };

                    if (filter.type === 'data') {
                        let dataArrayName = column.id + 'Array';
                        if (
                            column.id === 'laborScaling'
                            || column.id === 'materialScaling'
                        ) {
                            dataArrayName = 'scalingsArray';
                        }
                        filter.data = this[dataArrayName] ?? [];
                    } else if (filter.type === 'bool') {
                        filter.type = 'boolean';
                        filter.data = [
                            {id: 0, name: i18n.t('unset')},
                            {id: 1, name: i18n.t('active')},
                            {id: 2, name: i18n.t('inactive')},
                        ];
                    }

                    // restrict filters available data to the availableFilterValues of current column
                    // if this is null or empty, keep all data
                    let availableValues = this.availableFilterValues[column.id];
                    if (
                        availableValues
                        && availableValues.length > 0
                    ) {
                        // get intersect all array with read available values
                        let arrayData = [];
                        filter.data.forEach((entry) => {
                            if (availableValues.includes(entry.id)) {
                                arrayData.push(entry);
                            }
                        })

                        // set filter data
                        filter.data = arrayData;
                    }

                    filters.push(filter);
                }
            }

            return filters;
        },
        isoCodesArray() {
            return this.convertCodes('isoCode', true);
        },
        locationCodesArray() {
            return this.convertCodes('locationCode', true);
        },
    }
}
</script>

<style>

    div.editor-table.cedex-codes table.vcs-table td {
        padding: 0;
    }
    td div.v-input.v-text-field {
        padding: 0;
        margin: 0;
    }
    td div.v-input.v-text-field div.v-input__control div.v-input__slot {
        margin: 0;
    }
    td div.v-input.v-text-field div.v-input__control div.v-input__slot:after {
        border: none
    }
    td div.v-input.v-text-field div.v-input__control div.v-input__slot div.v-text-field__slot input {
        padding: 8px;
        font-size: 14px;
    }
    td div.v-input.v-text-field div.v-input__control div.v-text-field__details {
        display: none;
    }
</style>
